export default __webpack_public_path__ + "static/media/cerasiforme.eddd39a2.jpg";